<template>
  <div>
    <button @click="dialog=true">
      <img id="button-img" :src="img_src" :alt="title" />
    </button>
    <v-dialog v-model="dialog" :width="dialog_width">
      <slot/>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    title: {
      type: String,
    },
    img_src: {
      type: String,
    },
    dialog_width: {
      type: String,
      default: 'auto'
    }
  },
  data () {
    return {
      dialog: false,
    }
  },
}
</script>

<style scoped>
button {
  outline: none;
}
#button-img {
  width:100%;
  max-width: 300px;
}
</style>

<style>
.v-dialog {
  border-radius: 0 !important;
}
</style>